export const impacts = [
  { id: 0, name: "Bas" },
  { id: 1, name: "Moyen" },
  { id: 2, name: "Haut" },
];

export const impactsColors = [
  { id: 0, color: "#055a09" },
  { id: 1, color: "#e77000" },
  { id: 2, color: "#cc0000" },
];

export const priorities = [
  { id: 0, name: "Basse" },
  { id: 1, name: "Moyenne" },
  { id: 2, name: "Haute" },
];

export const prioritiesColors = [
  { id: 0, color: "#055a09" },
  { id: 1, color: "#e77000" },
  { id: 2, color: "#cc0000" },
];

export const statuses = [
  { id: 0, name: "À faire" },
  { id: 1, name: "En cours" },
  { id: 2, name: "Terminé" },
  { id: 3, name: "Bloqué" },
];

export const statusesColors = [
  { id: 0, color: "#1b35ce" },
  { id: 1, color: "#e09500" },
  { id: 2, color: "#045d04" },
  { id: 3, color: "#800505" },
];

export const deviceList = [
  { id: 15, name: "Mobile" },
  { id: 16, name: "Desktop" },
  { id: 17, name: "Tablette" },
];

export const getDeviceName = (deviceId) => {
  return deviceList.find((device) => device.id === deviceId).name;
};

export const getStatusColor = (statusId) => {
  return statusesColors.find((status) => status.id === statusId).color;
};

export const getStatusName = (statusId) => {
  return statuses.find((status) => status.id === statusId).name;
};

export const ranges = {
  LCP: [2500, 4000],
  INP: [200, 500],
  CLS: [0.1, 0.25],
  FCP: [1800, 3000],
  TTFB: [800, 1800],
};

export const rangesColors = {
  green: "#e3ffc3",
  orange: "#feddaa",
  red: "#ffdfdd",
};

export const fullRanges = {
  lcp: [
    [0, 2550],
    [2550, 4000],
    [4000, 40000],
  ],
  inp: [
    [0, 200],
    [200, 500],
    [500, 10000],
  ],
  cls: [
    [0, 0.1],
    [0.1, 0.25],
    [0.25, 10],
  ],
  fcp: [
    [0, 1800],
    [1800, 3000],
    [3000, 30000],
  ],
  ttfb: [
    [0, 800],
    [800, 1800],
    [1800, 10000],
  ],
};

export const formatLcp = (value) => {
  return value === undefined || isNaN(value)
    ? "--"
    : `${(value / 1000).toFixed(2)}s`;
  // return `${(value / 1000).toFixed(2)}s`;
};

export const formatInp = (value) => {
  return value === undefined || isNaN(value) ? "--" : `${value}ms`;
  // return `${value}ms`;
};

export const formatCls = (value) => {
  return value === undefined || isNaN(value) ? "--" : `${value.toFixed(2)}`;
};

export const formatFcp = (value) => {
  return value === undefined || isNaN(value)
    ? "--"
    : `${(value / 1000).toFixed(2)}s`;
  // return `${(value / 1000).toFixed(2)}s`;
};

export const formatTtfb = (value) => {
  return value === undefined || isNaN(value) ? "--" : `${Math.round(value)}ms`;
  // return `${Math.round(value)}ms`;
};

export const formatCwvMetric = (value, type) => {
  switch (type) {
    case "LCP":
      return formatLcp(value);
    case "INP":
      return formatInp(value);
    case "CLS":
      return formatCls(value);
    case "FCP":
      return formatFcp(value);
    case "TTFB":
      return formatTtfb(value);
    default:
      return value;
  }
};
